import _ from "lodash"

export const throttleFunction = (fn, options = {time: 1000, leading: true, trailing: true}) => {
  const {time, leading, trailing} = options
  return _.throttle(fn, time, { leading: leading, trailing: trailing })
}